/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsaenderungsAntragDto } from '../../models/buchungsaenderungs-antrag-dto';
import { CreateBuchungsaenderungsAntragDto } from '../../models/create-buchungsaenderungs-antrag-dto';

export interface CreateBuchungsaenderungsAntrag$Json$Params {

/**
 * ID der Buchung, für die der Antrag erstellt werden soll
 */
  buchungId: string;
  
    /**
     * Änderungsdaten für den Antrag
     */
    body?: CreateBuchungsaenderungsAntragDto
}

export function createBuchungsaenderungsAntrag$Json(http: HttpClient, rootUrl: string, params: CreateBuchungsaenderungsAntrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungsaenderungsAntragDto>> {
  const rb = new RequestBuilder(rootUrl, createBuchungsaenderungsAntrag$Json.PATH, 'post');
  if (params) {
    rb.path('buchungId', params.buchungId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungsaenderungsAntragDto>;
    })
  );
}

createBuchungsaenderungsAntrag$Json.PATH = '/v1/buchungen/{buchungId}/aenderungsAntraege';
